import React from "react";
import { validFilterTypesForDataTypes, operatorToDisplayValue } from "../../../backend/helpers/filteringHelper";
import { PropertyDataType } from "../../../backend/constants/datatypes";
import { FilterOperator } from "../../../backend/constants/filterOperators";
import sortBy from "lodash/sortBy";
import { withTranslation, WithTranslation } from "react-i18next";
import Select from "react-select";

// TODO: handle unselect???

export interface SelectOption {
  value: string;
  label: string;
}

interface IProps extends WithTranslation {
  visible: boolean;
  propertyDataType: PropertyDataType;
  selectedOperator: FilterOperator;
  onChange: (filterOperator: FilterOperator) => void;
}

const FilterOperatorSelect = (props: IProps) => {
  const { t } = props;
  const validFilterTypes = sortBy(validFilterTypesForDataTypes.get(props.propertyDataType));
  const selectedIndex = validFilterTypes.findIndex((ft) => ft === props.selectedOperator);

  const validFilterOptions = validFilterTypes.map((f) => ({ value: t(operatorToDisplayValue.get(f)), label: t(operatorToDisplayValue.get(f)) } ) );

  const onSelect = ([selectedIdx, ..._]) => props.onChange(selectedIdx != null ? validFilterTypes[selectedIdx] : null);

  return (
    <div>
      <Select
        options={validFilterOptions}
        defaultValue={ validFilterOptions[selectedIndex] || null }
        value={ validFilterOptions[selectedIndex] || null }
        isMulti={false}
        placeholder={`${t("command.select")}...`}
        styles={{ 
          menuPortal: (base) => ({ ...base, zIndex: 9999, borderRadius: 'none'}), 
          control: (base) => ({...base, background: 'white', border: '1px solid #78899a', borderRadius: 'none'}),
          multiValue: (base) => ({...base, fontSize: "16px"}), //multiValue child has 85% font
          option: provided => ({...provided, color: 'black', borderRadius: 'none'}),
        }}
        onChange={(e) => {
          const selectedIndex = validFilterOptions.findIndex((value: SelectOption) => value.value === e.value)
          onSelect ( [selectedIndex] )
        }}
      />
    </div>
  );
};

export default withTranslation()(FilterOperatorSelect);
